export default (state = {mentorName: '', profession: '', reason: '', twitter: '', email: '', canContact: true}, action) => {
    
    if (action.type === 'SET_NAME') {
        state['mentorName'] = action['mentorName'];
    }

    if (action.type === 'SET_PROF') {
        state['profession'] = action['profession'];
    }

    if (action.type === 'SET_REASON') {
        state['reason'] = action['reason'];
    }

    if (action.type === 'SET_TWITTER') {
        state['twitter'] = action['twitter'];
    }

    if (action.type === 'SET_EMAIL') {
        state['email'] = action['email'];
    }

    if (action.type === 'SET_CAN_CONTACT') {
        state['canContact'] = action['canContact'];
    }

    return state;
};


// WEBPACK FOOTER //
// ./src/reducers/new_mentor.js